import React from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import { MultiPin } from "@mapmycustomers/shared/types/map";

import { getMultiPin } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

const messages = defineMessages({
  multiPin: {
    id: "map.recordList.mapMode.title.multiPin",
    defaultMessage: "Multiple Records",
    description: "Selected Pins - multi-pin title",
  },
  title: {
    id: "map.recordList.mapMode.title.selectedPins",
    defaultMessage: "Selected Pins",
    description: "Selected Pins - default title",
  },
});

interface Props {
  multiPin?: MultiPin;
}

const Title: React.FC<Props> = ({ multiPin }) => {
  const intl = useIntl();
  const isMultiPinMode = !!multiPin;

  return (
    <>
      {isMultiPinMode ? intl.formatMessage(messages.multiPin) : intl.formatMessage(messages.title)}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  multiPin: getMultiPin(state),
});

export default connect(mapStateToProps)(Title);
